import * as React from 'react'
import { MoreButton } from '@sales-center/components'
import { SalesCenterWebhook } from '@user/store/scWebHooks/typings'

interface Props {
  webhook: SalesCenterWebhook
  handleEditClick: (webhook: SalesCenterWebhook) => void
  handleDeleteRequest: (id: number) => void
}

export function ActionMenu(props: Props) {
  const { webhook, handleEditClick, handleDeleteRequest } = props

  return (
    <>
      <MoreButton
        dataTestId={`webhookActionsMoreBtn-${webhook.id}`}
        style={{ color: '#091B2A8F' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        options={[
          {
            label: 'Edit',
            onClick: () => handleEditClick(webhook),
            dataTestId: 'webhookEditOption',
          },
          {
            label: 'Delete',
            onClick: () => handleDeleteRequest(Number(webhook.id)),
            dataTestId: 'webhookDeleteOption',
          },
        ]}
      />
    </>
  )
}
